<!-- VES: solo referencia (campo en el formulario padre). Sin campos extra. -->
<ng-container></ng-container>
